import deepmerge from "@node/deepmerge"
import { createI18n } from "@node/vue-i18n"

const user = JSON.parse(localStorage.getItem('current_user')) || { locale: 'en' }

let messages = {}

const modules = import.meta.glob("@o-din/../../config/locales/**/*.yml", { eager: true })

for (const path in modules) {
  messages = deepmerge(messages, modules[path].default);
}

export default createI18n({
  locale: user.locale, messages
})
